import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableColumnComponent } from '../table-column/table-column.component';

@Component({
    selector: 'app-column-date',
    templateUrl: './column-date.component.html',
    styleUrls: ['./column-date.component.scss'],
    standalone: false,
})
export class ColumnDateComponent extends TableColumnComponent {
    @Output() public StartFilterChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() public EndFilterChange: EventEmitter<string> = new EventEmitter<string>();

    protected startFilterValue: string;
    protected endFilterValue: string;

    @Input()
    public get StartFilter(): string {
        return this.startFilterValue;
    }

    public set StartFilter(value: string) {
        this.startFilterValue = value;
        this.StartFilterChange.emit(this.startFilterValue);
    }

    @Input()
    public get EndFilter(): string {
        return this.endFilterValue;
    }

    public set EndFilter(value: string) {
        this.endFilterValue = value;
        this.EndFilterChange.emit(this.endFilterValue);
    }

    public get PresentDate(): string {
        return new Date().toDateString();
    }
}
